import styled from 'styled-components';

const StyledFormFooter = styled.footer`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  margin: 1rem 0 0;

  button {
    margin-left: 1rem;
  }

	${props => props.centered && `
    justify-content: center !important;
    button {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  `}

	${props => props.column && `
    flex-direction: column !important;
    align-items: center;
    button {
      margin-left: 0 !important;
    }

    > * {
      margin-bottom: 1rem;
    }
  `}
`;

export default StyledFormFooter;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledFormFooter.js